import clsx from 'clsx';
import { forwardRef, HtmlHTMLAttributes, useState } from 'react';

import { Skeleton } from '@flintmint/web-shared/components/skeleton';

import { useUser } from '@/hooks/rxdb-models';
import { getAuthUser } from '@flintmint/web-shared/hooks/use-auth-user';

import styles from './avatar.module.scss';

export const Avatar = forwardRef((props: AvatarProps, ref: any) => {
  const { className, ...restProps } = props;

  const authUser = getAuthUser();
  const { data: user, isLoading } = useUser();

  const [profilePicFailed, setProfilePicFailed] = useState(false);

  const initial = (user?.firstName ?? user?.email ?? '')[0];

  return isLoading ? (
    <Skeleton width={36} height={36} borderRadius="100%" />
  ) : (
    <div className={clsx(styles.avatar, className)} {...restProps} ref={ref}>
      {!!authUser?.picture && !profilePicFailed ? (
        <img alt="User avatar" src={authUser.picture} onError={() => setProfilePicFailed(true)} />
      ) : (
        initial
      )}
    </div>
  );
});

interface AvatarProps extends HtmlHTMLAttributes<HTMLDivElement> {}
